import React, { useContext, useState } from 'react';
import { ButtonNoStyles, SectionWrapperInner, SectionWrapperOuter } from '@styled';
import ErrorHandler from '../../../_molecules/ErrorHandler';
import TrackPageView from '@react/tracking/TrackPageView';
import { requestPasswordReset } from '@general/api/memberAPI';
import PropTypes from 'prop-types';
import { LoadingContext } from '@context/LoadingProvider';

const LoggedInResetPassword = ({ email: username }) => {
    const { setIsLoading } = useContext(LoadingContext);

    const [requested, setRequested] = useState(false);

    const request = async () => {
        setIsLoading(true);

        try {
            await requestPasswordReset(
                username,
                `${window.location.origin}/login/reset-password/authenticate`,
                `${window.location.origin}/login/magic-link/authenticate`
            );
        } catch (e) {
            console.log(e);
        }

        setIsLoading(false);
        setRequested(true);
    };

    return (
        <ErrorHandler>
            <TrackPageView>
                <SectionWrapperOuter>
                    <SectionWrapperInner className="fade-in-fast">
                        {!requested && (
                            <>
                                <h2 className="display5 bold mb-4 text-center">Update your password</h2>
                                <p className="text-center mb-3 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                                    <ButtonNoStyles onClick={request} style={{ fontSize: '1rem' }} className="accent">
                                        Click here to request an an email
                                    </ButtonNoStyles>{' '}
                                    with a link to reset your password. The link will expire in 2 hours.
                                </p>
                            </>
                        )}

                        {requested && (
                            <>
                                <h2 className="display5 bold mb-4 text-center">Check your email</h2>
                                <p className="text-center mb-3 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                                    We have sent an email to the address on file for your account. Follow the
                                    instructions in the email to reset your password.
                                </p>
                            </>
                        )}

                        <p className="text-center mb-3 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                            Still need help?
                        </p>

                        <p className="text-center mb-4 red-hat" style={{ fontSize: '1rem', lineHeight: 1.4, width: '95%' }}>
                            <a className="accent" href="mailto:membership@icsc.com">
                                Contact us.
                            </a>
                        </p>
                    </SectionWrapperInner>
                </SectionWrapperOuter>
            </TrackPageView>
        </ErrorHandler>
    );
};

LoggedInResetPassword.propTypes = {
    email: PropTypes.string,
};

export default LoggedInResetPassword;
